import script from "./cancelSure.vue?vue&type=script&setup=true&lang=js"
export * from "./cancelSure.vue?vue&type=script&setup=true&lang=js"

import "./cancelSure.vue?vue&type=style&index=0&id=023e993b&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023e993b"]])

export default __exports__